"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Restricted = function Restricted(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.0002 4C12.2521 4 9.76 5.11598 7.94797 6.91601C7.94395 6.92002 7.9319 6.92404 7.92805 6.92806C7.92001 6.9361 7.92001 6.94413 7.91198 6.952C6.11195 8.76009 5 11.2519 5 14C5 19.5162 9.48379 24 15 24C17.7441 24 20.236 22.8881 22.048 21.088C22.052 21.08 22.0641 21.08 22.0679 21.072C22.076 21.0639 22.08 21.0559 22.084 21.048C23.884 19.2399 25 16.7481 25 14C25 8.48809 20.5122 4 15.0002 4ZM15.0002 23.2003C9.92415 23.2003 5.79994 19.0723 5.79994 14C5.79994 11.608 6.71602 9.42795 8.2199 7.78778L11.2119 10.7798L12 11.5L13.5 13L15 14.5L18.0162 17.5838L21.2123 20.7799C19.5723 22.2839 17.3924 23.2003 15.0002 23.2003ZM21.7761 20.2123L18.7842 17.2203L16.4363 14.8762C16.4363 14.8762 14.9301 13.422 14.8581 13.2981L13.9291 12.3991L13 11.5L11.9762 10.4163L8.78417 7.2242C10.4242 5.72014 12.6042 4.80007 15.0003 4.80007C20.0725 4.80007 24.2006 8.92814 24.2006 14.0004C24.2006 16.3924 23.2802 18.576 21.7761 20.2123Z",
    fill: "#7F0442"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.6362 15.0762L13.9241 12.3641M16.4363 14.8762L18.7842 17.2203L21.7761 20.2123C23.2802 18.576 24.2006 16.3924 24.2006 14.0004C24.2006 8.92814 20.0725 4.80007 15.0003 4.80007C12.6042 4.80007 10.4242 5.72014 8.78417 7.2242L11.9762 10.4163L13 11.5L13.9291 12.3991L14.8581 13.2981M16.4363 14.8762C16.4363 14.8762 14.9301 13.422 14.8581 13.2981M16.4363 14.8762L14.8581 13.2981M15.0002 4C12.2521 4 9.76 5.11598 7.94797 6.91601C7.94395 6.92002 7.9319 6.92404 7.92805 6.92806C7.92001 6.9361 7.92001 6.94413 7.91198 6.952C6.11195 8.76009 5 11.2519 5 14C5 19.5162 9.48379 24 15 24C17.7441 24 20.236 22.8881 22.048 21.088C22.052 21.08 22.0641 21.08 22.0679 21.072C22.076 21.0639 22.08 21.0559 22.084 21.048C23.884 19.2399 25 16.7481 25 14C25 8.48809 20.5122 4 15.0002 4ZM15.0002 23.2003C9.92415 23.2003 5.79994 19.0723 5.79994 14C5.79994 11.608 6.71602 9.42795 8.2199 7.78778L11.2119 10.7798L12 11.5L13.5 13L15 14.5L18.0162 17.5838L21.2123 20.7799C19.5723 22.2839 17.3924 23.2003 15.0002 23.2003Z",
    stroke: "#7F0442"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0156 18.1876C19.7188 18.0782 22 14.3595 22 14.0001C22 13.6407 19.4531 9.73454 15.0156 9.8126C10.5938 9.60949 8.03125 13.6407 8.03125 14.0001C8.03125 14.3595 10.3919 18.2951 15.0156 18.1876ZM15 15.9871C16.0981 15.9871 16.9883 15.0969 16.9883 13.9988C16.9883 12.9007 16.0981 12.0105 15 12.0105C13.9019 12.0105 13.0117 12.9007 13.0117 13.9988C13.0117 15.0969 13.9019 15.9871 15 15.9871Z",
    fill: "#7F0442"
  }));
};

Restricted.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
Restricted.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = Restricted;
exports.default = _default;